import React, { Component } from 'react'
import imageResponsive from '../img/dormitorios/welcomeBg_responsive.jpg'
import imagePrincipal from '../img/dormitorios/welcomeBg.jpg'
import IconArrow from '../icons/IconArrow'
import Social from '../componentes/Social'
import 'firebase/firestore'
import firebase from '../lib/Config'
import Footer from '../componentes/Footer'

class Dormitorios extends Component{
    _isMounted = false;
    constructor(props) {
        super(props)
        this.ref_rooms = firebase.firestore().collection("rooms").orderBy("order", "desc")
        this.unsubscribe_rooms = null
        this.state = {
            rooms: [],
            bgBanner: imagePrincipal,
            bgResponsive: imageResponsive,
            typeMoney: 'S/ '
        };
    }
    updateDimensions() {
        if(window.innerWidth < 768) {
            if (this._isMounted) {
                this.setState({ 
                    bgBanner: imageResponsive
                })
                this.getImageLazy(this.state.bgResponsive)
            }
        } else {
            let bgBanner = imagePrincipal
            if (this._isMounted) {
                this.setState({ 
                    bgBanner: bgBanner
                })
                this.getImageLazy(this.state.bgBanner)
            }
        }
    }
    getImageLazy(url){
        let imgEl = document.getElementsByClassName('lazy');
        for (let i=0; i < imgEl.length; i++) {
            if( imgEl[i].getAttribute('data-src')) {
                imgEl[i].setAttribute('src', url);
                imgEl[i].removeAttribute('data-src');
            }
        }
    }
    onCollectionUpdateRooms = (querySnapshot) => {
        const rooms = []
        querySnapshot.forEach((doc) => {
            rooms.push(
                Object.assign({
                    id: doc.id
                }, doc.data())
            )
        });
        this.setState({
            rooms
        });
    }  
	scrollIt(element) {  
		window.scrollTo({
			'behavior': 'smooth',
			'left': 0,
			'top': element.offsetTop
		});
	}
    componentDidMount() {
        this._isMounted = true;
        let btnDown = document.querySelectorAll('.btn-arrow'),
            secRooms = document.querySelectorAll('.ourrooms')

        document.getElementById("footer").classList.add("footer-rooms")
        
        this.updateDimensions();
        window.addEventListener("resize", this.updateDimensions.bind(this));
        this.unsubscribe_rooms = this.ref_rooms.onSnapshot(this.onCollectionUpdateRooms);

		btnDown[0].addEventListener('click', () => {
			this.scrollIt(secRooms[0]);
		});
    }
    componentWillUnmount() {
        this._isMounted = false;
        window.removeEventListener("resize", this.updateDimensions.bind(this));
    }
    render(){
        const rooms = this.state.rooms
        return (
            <React.Fragment>
                <main id="rooms_main" className="f fd-c f-ac">
                    <article className="gwr">
                        <div className="text-mask">
                            <h1 className="parragraph--first"><span>Nuestras habitaciones</span></h1>
                            <p className="parragraph--third"><span>Te mostramos las categorías de cuartos que tenemos para ti.</span></p>
                        </div>
                    </article>
                    <figure className="iron-image__container">
                        <img data-src={this.state.bgBanner} className="lazy iron-image iron-image--fade-in" alt="Spring's Hotel" />
                    </figure>
                    <Social />
                    <button className="btn-arrow">
                        <IconArrow color='#FFFFFF' height='32px' />
                    </button>
                </main>
                <section id="our_rooms" className="ourrooms">           
                    {rooms.map(room =>
                    <React.Fragment key={room.id}>
                        <article className="room__item f f-ww">
                            <div className="room__content">
                                <div className="room__item--title">
                                    <h2>{room.name}</h2>
                                    <strong><span>{this.state.typeMoney}</span>{room.price}</strong>
                                </div>
                                <p className="room__item--paragraph">{room.description}</p>
                                <h3>Servicios:</h3>
                                <ul className="room__list f f-ww">
                                    {room.services.map(service =>
                                        (service && service.length > 0 ) ?
                                        <li key={service.toString()} 
                                            className={ 'icon-' + room.services.indexOf(service)}
                                        >
                                            <span>
                                                {service}
                                            </span>
                                        </li>
                                        :
                                        ''
                                    )}
                                </ul>
                            </div>
                            <figure className="room__wrap--image">
                                <img className="lazy" src={room.image} alt={room.name} />
                            </figure>
                        </article>
                    </React.Fragment>
                    )}
                </section>
                <Footer />
            </React.Fragment>
        )
    }
}

export default Dormitorios;